/* Lune — scroll reveal + quick-add wiring */
(function(){
  function initReveal(){
    var els=document.querySelectorAll('.lune-reveal');
    if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('is-in');});return;}
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(en){if(en.isIntersecting){en.target.classList.add('is-in');io.unobserve(en.target);}});
    },{threshold:.12,rootMargin:'0px 0px -8% 0px'});
    els.forEach(function(e){io.observe(e);});
  }
  // quick add -> posts to /cart/add then opens cart drawer if present
  function initQuickAdd(){
    document.addEventListener('click',function(ev){
      var btn=ev.target.closest('.lune-card__add');
      if(!btn)return;
      ev.preventDefault();
      var id=btn.getAttribute('data-variant');
      if(!id)return;
      var orig=btn.textContent;
      btn.textContent='Adding…';btn.disabled=true;
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:id,quantity:1}]})})
        .then(function(r){return r.json();})
        .then(function(){
          btn.textContent='Added ✓';
          var drawer=document.querySelector('cart-drawer, .cart-drawer, #CartDrawer');
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          if(drawer&&drawer.open){try{drawer.open();}catch(e){}}
          setTimeout(function(){btn.textContent=orig;btn.disabled=false;},1600);
        })
        .catch(function(){btn.textContent='Try again';setTimeout(function(){btn.textContent=orig;btn.disabled=false;},1600);});
    });
  }
  if(document.readyState!=='loading'){initReveal();initQuickAdd();}
  else document.addEventListener('DOMContentLoaded',function(){initReveal();initQuickAdd();});
  document.addEventListener('shopify:section:load',initReveal);
})();
